module.exports = __webpack_public_path__ + "static/portfolio4-68d7c08728ae30e7c2bb7b0738ccc0ff.jpg";